<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col xl="4" lg="5" md="6" cols="12" class="px-10">
                    <h1 class="mb-5">Engage Members at Scale</h1>
                    Membership associations live and die on engagement. Yabbr makes it easy to deliver timely updates, event invitations, and promotions that actually get read — whether to a hundred members or a hundred thousand.
                    <div>
                        <v-list class="features">
                            <v-list-item v-for="item in items" :key="item">
                                <v-list-item-icon>
                                    <v-icon color="primary">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-text>{{ item }}</v-list-item-text>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                    <v-btn
                    class="btn-primary--outline rounded-pill mt-8"
                    outlined
                    large
                    :ripple="false"
                    href="/campaigns"
                    >
                    Campaigns
                    <v-icon>mdi-arrow-right-thin</v-icon>
                </v-btn>
                </v-col>
                <v-col xl="4" lg="4" md="6" col="12" class="d-flex align-center justify-center px-10">
                    <v-img
                    src="../assets/img/general-yabbr.png"
                    contain
                    max-width="400px"
                    alt="sitemap"
                    class="rounded-xl"
                    
                     /> 
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsFeatures',
    data: () => ({
        items: [
            'SMS and Email campaigns for events, news, and newsletters',
            'MMS for visual content like agendas, maps, and documents',
            'Opt-outs and preferences tracked automatically',
        ]
    })
}
</script>




<style lang="scss">

</style>